// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1RZFA","noInteraction":"EventWrapper_noInteraction__b3ylf","pointerPassthrough":"EventWrapper_pointerPassthrough__2IbHO"};